import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { types } from 'constants/invoices';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError } from 'utils';

export const InvoiceTypesSelect = ({
  label,
  margin,
  variant,
  disabled,
  omitFields,
  asyncErrors,
  sharingTypeFFB,
  field: { name, value },
  form: { errors, touched, setFieldValue },
}) => {
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    if (value || value === '') {
      const defaultVal = types.find((status) => status === value);

      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue('');
      }
    }
  }, [value, types]);

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      id="invoice-types"
      disabled={disabled}
      value={defaultValue}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      options={types.filter((value) => omitFields.indexOf(value))}
      getOptionSelected={(option, value) => option === value || ''}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionLabel={(option) =>
        option ? i18n.t(`${sharingTypeFFB ? 'statementTypes' : 'invoicesTypes'}.${option}`) : ''
      }
    />
  );
};

InvoiceTypesSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

InvoiceTypesSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  omitFields: [],
  label: 'Status',
  variant: 'standard',
};
